import { useState } from "react";
import { useActiveFamily } from "../../context/ActiveFamilyContext";
import { useFamilyMode } from "../../context/FamilyModeContext";
import FamilySwitcherModal from "./FamilySwitcherModal";
import { t } from "i18next";

export default function FamilySwitcher() {
  const { activeFamily, availableFamilies, loading } = useActiveFamily();
  const { enabled: familyMode } = useFamilyMode();
  const [modalOpen, setModalOpen] = useState(false);

  // TEMPORAL: Hardcodeado para prueba visual
  // TODO: Descomentar la línea de abajo para producción
  // if (loading || availableFamilies.length <= 1) {
  //   return null;
  // }

  const isGroup = (activeFamily as any)?.type === 'group';
  const icon = isGroup ? '👥' : '🏠';

  // Bloquear en modo grupo
  const isDisabled = familyMode;

  return (
    <>
      {/* Mobile/Tablet: Estilo similar al de notificaciones pero con nombre */}
      <button
        onClick={() => !isDisabled && setModalOpen(true)}
        disabled={isDisabled || loading}
        className={`lg:hidden flex items-center gap-2 px-3 h-10 rounded-full bg-white/20 dark:bg-white/10 text-[#055590] transition-all active:scale-95 border border-[#055590]/10 ${isDisabled || loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <span className="text-lg leading-none">{icon}</span>
        <span className="text-xs font-black truncate max-w-[100px]">
          {loading ? t('common.loading', 'Cargando...') : (activeFamily?.name || t('groups.sinfamilia'))}
        </span>
        {!isDisabled && !loading && (
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
          </svg>
        )}
      </button>

      {/* Desktop: Estilo dropdown como UserDropdown */}
      <button
        onClick={() => !isDisabled && setModalOpen(true)}
        disabled={isDisabled || loading}
        className={`hidden lg:flex items-center gap-2 rounded-full hover:bg-white/20 dark:hover:bg-white/10 p-2 transition-colors ${isDisabled || loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 text-white text-sm font-medium">
          {icon}
        </div>
        <span className="font-black text-theme-sm max-w-[140px] truncate text-[#055590]">
          {loading ? t('common.loading', 'Cargando...') : (activeFamily?.name || t('groups.sinfamilia'))}
        </span>
        {!isDisabled && !loading && (
          <svg
            className={`stroke-[#055590] dark:stroke-gray-400 transition-transform duration-200 ${modalOpen ? "rotate-180" : ""}`}
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4.3125 8.65625L9 13.3437L13.6875 8.65625" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </button>

      <FamilySwitcherModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
